module.exports = __webpack_public_path__ + "img/h2.ad57d213.png";